import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, Form, Input, Button, Typography, Alert } from 'antd'
import { KeyOutlined, HomeOutlined } from '@ant-design/icons'
import axios from 'axios'

const { Title, Text } = Typography

const Login: React.FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async ({ apiKey }: { apiKey: string }) => {
    setLoading(true)
    setError(null)
    try {
      await axios.get('/api/health', { headers: { 'X-API-Key': apiKey } })
      localStorage.setItem('kredit_api_key', apiKey)
      navigate('/dashboard', { replace: true })
    } catch (err: any) {
      if (err.response?.status === 401 || err.response?.status === 403) {
        setError('API key inválida. Verifica las credenciales.')
      } else {
        // Unreachable API — accept key anyway so offline debugging is possible
        localStorage.setItem('kredit_api_key', apiKey)
        navigate('/dashboard', { replace: true })
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#001529',
      }}
    >
      <Card
        style={{ width: 400, borderRadius: 12 }}
        styles={{ body: { padding: '40px 32px' } }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <HomeOutlined style={{ fontSize: 40, color: '#1890ff', marginBottom: 12 }} />
          <Title level={3} style={{ margin: 0 }}>
            Kredit Plus
          </Title>
          <Text type="secondary">CreditFlow AI – Panel operativo</Text>
        </div>

        {error && (
          <Alert
            type="error"
            message={error}
            style={{ marginBottom: 20 }}
            showIcon
          />
        )}

        <Form layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="apiKey"
            label="API Key"
            rules={[{ required: true, message: 'Ingresa tu API key' }]}
          >
            <Input.Password
              prefix={<KeyOutlined style={{ color: '#bfbfbf' }} />}
              placeholder="••••••••••••"
              size="large"
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              loading={loading}
            >
              Ingresar
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

export default Login
